export default __webpack_public_path__ + "static/media/kids.5fbedf78.png";